if (!customElements.get('speakon-agent-creators')) {
  customElements.define('speakon-agent-creators', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.resize?.disconnect();
      clearTimeout(this.scrollTimer);
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.track = this.querySelector('[data-track]');
      this.cards = [...this.querySelectorAll('[data-card]')];
      if (!this.track || !this.cards.length) return;
      this.controls = this.querySelector('[data-controls]');
      this.previous = this.querySelector('[data-step="-1"]');
      this.next = this.querySelector('[data-step="1"]');
      this.status = this.querySelector('[data-page-status]');
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.page = 0;
      const settle = () => {
        clearTimeout(this.scrollTimer);
        this.page = Math.max(0, Math.min(this.pages - 1, Math.round(this.track.scrollLeft / this.stride)));
        this.updateControls();
      };
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(settle, 150);
      }, { ...options, passive: true });
      this.track.addEventListener('scrollend', settle, options);
      const goTo = (page, instant = false) => {
        this.page = Math.max(0, Math.min(this.pages - 1, page));
        this.track.scrollTo({ left: this.page * this.stride, behavior: instant || reducedMotion.matches ? 'instant' : 'smooth' });
        this.updateControls();
      };
      this.addEventListener('click', event => {
        const step = event.target.closest('[data-step]');
        if (step) goTo(this.page + Number(step.dataset.step), event.detail === 0);
        const opener = event.target.closest('[data-open-video]');
        if (opener) {
          const dialog = this.querySelector('#' + CSS.escape(opener.getAttribute('aria-controls')));
          if (!dialog) return;
          dialog.showModal();
          dialog.querySelector('video')?.play().catch(() => { /* Native controls remain available. */ });
        }
        if (event.target.closest('[data-close-video]')) event.target.closest('dialog').close();
      }, options);
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        let page;
        if (event.key === 'ArrowLeft') page = this.page - 1;
        else if (event.key === 'ArrowRight') page = this.page + 1;
        else if (event.key === 'Home') page = 0;
        else if (event.key === 'End') page = this.pages - 1;
        else return;
        event.preventDefault();
        goTo(page, true);
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.cards.indexOf(event.target.closest('[data-card]'));
        if (index >= 0) goTo(Math.floor(index / this.columns), true);
      }, options);
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('click', event => {
          const box = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
        }, options);
        dialog.addEventListener('close', () => {
          const video = dialog.querySelector('video');
          if (video) { video.pause(); video.currentTime = 0; }
          this.querySelector('[aria-controls="' + CSS.escape(dialog.id) + '"]')?.focus();
        }, options);
      });
      const measure = () => {
        const columns = Number(getComputedStyle(this).getPropertyValue('--creator-columns')) || 4;
        const width = this.track.clientWidth;
        if (this.columns === columns && this.width === width) return;
        const firstCard = this.page * (this.columns || columns);
        this.columns = columns;
        this.width = width;
        this.stride = width + parseFloat(getComputedStyle(this.track).columnGap);
        this.pages = Math.ceil(this.cards.length / columns);
        this.controls.hidden = this.pages < 2;
        goTo(Math.floor(firstCard / columns), true);
      };
      this.resize = new ResizeObserver(measure);
      this.resize.observe(this.track);
      measure();
    }

    updateControls() {
      this.previous.disabled = this.page === 0;
      this.next.disabled = this.page >= this.pages - 1;
      this.status.textContent = this.status.dataset.template.replace('[current]', this.page + 1).replace('[total]', this.pages);
    }

    disconnectedCallback() {
      this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
      this.querySelectorAll('video').forEach(video => video.pause());
      this.events?.abort();
      this.resize?.disconnect();
      clearTimeout(this.scrollTimer);
    }
  });
}
